import Cookies from 'js-cookie';
import { getsysconfig } from '@/api/system';
var state = {
  sidebar: {
    opened: false,
    withoutAnimation: false
  },
  device: 'desktop',
  language: 'en',
  size: 'medium',
  height: 950,
  system: '',
  adminUrl: '',
  dcmviwerurl: '',
  // 
  appInfo: '',
  nodeEnv: process.env.NODE_ENV
};
var mutations = {
  TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;

    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1);
    } else {
      Cookies.set('sidebarStatus', 0);
    }
  },
  CLOSE_SIDEBAR: function CLOSE_SIDEBAR(state, withoutAnimation) {
    Cookies.set('sidebarStatus', 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: function TOGGLE_DEVICE(state, device) {
    state.device = device;
  },
  SET_LANGUAGE: function SET_LANGUAGE(state, language) {
    state.language = language;
    Cookies.set('language', language);
  },
  SET_SIZE: function SET_SIZE(state, size) {
    state.size = size;
    Cookies.set('size', size);
  },
  SET_WINDOW_HEIGHT: function SET_WINDOW_HEIGHT(state, height) {
    if (height) {
      state.height = height;
    }
  },
  SET_SYSTEM_TYPE: function SET_SYSTEM_TYPE(state, type) {
    state.system = type;
  },
  SET_ADMIN_URL: function SET_ADMIN_URL(state, url) {
    state.adminUrl = url;
  },
  SET_DCMVIWER_URL: function SET_DCMVIWER_URL(state, url) {
    state.dcmviwerurl = url;
  },
  SET_APPINFO: function SET_APPINFO(state, info) {
    state.appInfo = info;
  }
};
var actions = {
  toggleSideBar: function toggleSideBar(_ref) {
    var commit = _ref.commit;
    commit('TOGGLE_SIDEBAR');
  },
  closeSideBar: function closeSideBar(_ref2, _ref3) {
    var commit = _ref2.commit;
    var withoutAnimation = _ref3.withoutAnimation;
    commit('CLOSE_SIDEBAR', withoutAnimation);
  },
  toggleDevice: function toggleDevice(_ref4, device) {
    var commit = _ref4.commit;
    commit('TOGGLE_DEVICE', device);
  },
  setLanguage: function setLanguage(_ref5, language) {
    var commit = _ref5.commit;
    commit('SET_LANGUAGE', language);
  },
  setSize: function setSize(_ref6, size) {
    var commit = _ref6.commit;
    commit('SET_SIZE', size);
  },
  setWindowHeight: function setWindowHeight(_ref7, height) {
    var commit = _ref7.commit;
    commit('SET_WINDOW_HEIGHT', height);
  },
  setSystemType: function setSystemType(_ref8, type) {
    var commit = _ref8.commit;
    return new Promise(function (resolve, reject) {
      getsysconfig().then(function (res) {
        if (res.info == 'ok') {
          res.productinfo.info.productname = res.productinfo.productname;
          commit('SET_SYSTEM_TYPE', res.islocal);
          commit('SET_ADMIN_URL', res.url);
          commit('SET_DCMVIWER_URL', res.dcmviwerurl);
          commit('SET_APPINFO', res.productinfo.info);
          resolve();
        } else {
          resolve();
        }
      }).catch(function (error) {
        console.log('catch:', error);
      });
    }).catch(function (error) {
      reject(error);
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};